export const ROUTER_SCROLL_BEHAVIORS = {
  INSTANT: "instant",
  SMOOTH: "smooth",
  AUTO: "auto",
};
